import React, { useState } from 'react';
import axios from "axios";
import { useTranslation } from 'react-i18next';
import '../css/footer.css';

export function Footer() {
    const { t, i18n } = useTranslation();
    const [mailSent, setMailSent] = useState<boolean | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [formData, setFormData] = useState<{ email: string }>({ email: "" });

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const API_URL = process.env.REACT_APP_NEWSLETTER_API || "";

    const handleFormSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        if (!API_URL) {
            console.error("API URL is missing! Check your environment variables.");
            setError("Server error. Please try again later.");
            setLoading(false);
            return;
        }

        try {
            const response = await axios.post(API_URL, formData, {
                headers: { "Content-Type": "application/json" },
            });

            if (response.status === 200) {
                setMailSent(true);
            } else {
                throw new Error("Failed to send message. Please try again.");
            }
        } catch (error) {
            console.error("Error sending newsletter:", error.response?.data || error.message);
            setMailSent(false);
            setError("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ email: e.target.value });
    };

    function closeStatus() {
        setError(null)
    }

    return (
        <div className="footer">
            <div className='row w80 h-center'>
                <div className="footer-wrap w50 col">
                    <div className='footer-contact-title'>Let’s stay in touch!</div>
                    <div className='footer-contact-subtitle'>
                        Sign up for Parla emails to be the first to know about new features, updates, and more.
                    </div>
                </div>

                <div className="footer-wrap w50">

                    <form onSubmit={handleFormSubmit} className='row'>
                        {mailSent && <div className="newsletter-status success"><i className="far fa-check"></i> Thank you! You've successfully subscribed to our newsletter.</div>}
                        {error && <div className="newsletter-status error"><div><i className="far fa-exclamation-triangle"></i>{error} </div><i className="far fa-times" onClick={closeStatus}></i></div>}
                        <input
                            type='email'
                            className='form-input'
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder="Enter your email"
                        />
                        <button type="submit" className='footer-submit' disabled={loading}>
                            {loading ? "Submitting..." : "Submit"}
                        </button>
                    </form>

                </div>
            </div>
            <div className='row w80 h-center'>
                <div className="footer-wrap w50">
                    <div className="copyright-img-wrap">
                        <a href="/"><img src="/img/parla-logo-368-x-74.png" alt="Parla Logo" /></a>
                    </div>
                </div>
                <div className="footer-wrap w50">
                    <div>
                        <div className="title">LEARN MORE</div>
                        <div className="list">
                            {/* <a href="https://parlaretail.com/blog/">Blog</a> */}
                            <a href="https://youtube.com/playlist?list=PLVxUny9NQVTVoS5RqNkWEg3y4NrSP8L9x&feature=shared">The Parla Parlor</a>
                            <a href="https://youtube.com/playlist?list=PLVxUny9NQVTXo3GXjBKvxcI_R4Y6AzJYI&feature=shared">Parla's CX Insights</a>
                            <a href="faq">FAQs</a>
                        </div>
                    </div>
                    <div>
                        <div className="title">COMPANY</div>
                        <div className="list">
                            <a href="integrations">Integrations</a>
                            <a href="partners">Become a partner</a>
                            <a href="press">Latest News</a>
                        </div>
                    </div>
                    <div>
                        <div className="title">CONNECT</div>
                        <div className="list">
                            <a href="contact"><i className="fas fa-envelope"></i> Contact Us</a>
                            <a href="https://uk.linkedin.com/company/parlaretail" target="_blank"><i className="fab fa-linkedin"></i> LinkedIn</a>
                            <a href="https://www.youtube.com/@ParlaRetail" target="_blank"><i className="fab fa-youtube"></i> YouTube</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright">
                <span>© Parla Retail Ltd. 2026. All Rights Reserved.</span>
            </div>
        </div>
    );
}
